export const types = {
  SET_CONFECTION_ENABLED: 'SET_CONFECTION_ENABLED',
  SET_SELECTED_CONFECTION_ITEM: 'SET_SELECTED_CONFECTION_ITEM',
  HANDLE_CONFECTION_ITEM_SELECTION: 'HANDLE_CONFECTION_ITEM_SELECTION',
  SET_SHOULD_SHOW_INCENTIVE_MODAL: 'SET_SHOULD_SHOW_INCENTIVE_MODAL',
  RESET_PERSONALIZATION: 'RESET_PERSONALIZATION',
  SET_DATA: 'SET_DATA',
  RESET: 'RESET',
};
